import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';

import type { AddRowDirection, AddRowFormState } from '../CharterFeederPricesConstants';
import { AIRPORT_CODE_LENGTH } from '../CharterFeederPricesConstants';

interface AddRowDialogProps {
  open: boolean;
  form: AddRowFormState;
  onChange: (updater: (current: AddRowFormState) => AddRowFormState) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function AddRowDialog({
  open,
  form,
  onChange,
  onCancel,
  onConfirm,
}: AddRowDialogProps): React.JSX.Element {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Add route row</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <DatePicker
            label="Date"
            value={form.date}
            onChange={(date) => onChange((current) => ({ ...current, date }))}
            format="DD/MM/YYYY"
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />

          <FormControl fullWidth size="small">
            <InputLabel id="add-row-direction-label">Direction</InputLabel>
            <Select
              labelId="add-row-direction-label"
              value={form.direction}
              label="Direction"
              onChange={(event) =>
                onChange((current) => ({ ...current, direction: event.target.value as AddRowDirection }))
              }
            >
              <MenuItem value="xToMel">x-&gt;MEL</MenuItem>
              <MenuItem value="melToX">MEL-&gt;x</MenuItem>
              <MenuItem value="custom">Custom</MenuItem>
            </Select>
          </FormControl>

          {form.direction === 'custom' && (
            <>
              <TextField
                label="Origin Airport"
                size="small"
                fullWidth
                value={form.customOriginAirportCode}
                onChange={(event) =>
                  onChange((current) => ({ ...current, customOriginAirportCode: event.target.value }))
                }
                slotProps={{ htmlInput: { maxLength: AIRPORT_CODE_LENGTH } }}
              />
              <TextField
                label="Destination Airport"
                size="small"
                fullWidth
                value={form.customDestinationAirportCode}
                onChange={(event) =>
                  onChange((current) => ({ ...current, customDestinationAirportCode: event.target.value }))
                }
                slotProps={{ htmlInput: { maxLength: AIRPORT_CODE_LENGTH } }}
              />
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained">
          Add Row
        </Button>
      </DialogActions>
    </Dialog>
  );
}
